<template>
    <b-modal
        id="assignment-show-ratings-detail-modal"
        :title="$t('assignment.assessment_overview')"
        modal-class="apprentice-default-modal"
        ok-only
        :ok-title="$t('common.close')"
        size="md">
        <div
            class="ratings"
            v-if="ratings.length">
            <b-list-group class="ratings-list-group">
                <b-list-group-item
                    class="rating-item"
                    v-for="rating in ratings"
                    :key="'assignment-rating-' + rating.id">
                    <div class="title">
                        {{ rating.name }}
                    </div>
                    <div class="rating">
                        {{ rating.rating_result }}
                    </div>
                </b-list-group-item>
            </b-list-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-assignment-show-ratings-details-model-component',
    props: {
        assignmentIn: Object,
    },
    data() {
        return {
            index: 1,
            feedbacks: this.feedbacksIn ? [...this.feedbacksIn] : null,
        };
    },
    computed: {
        ratings() {
            let allRatings = [];
            if (this.assignmentIn) {
                allRatings = this.assignmentIn.sub_assignments.map((subAssignment) => {
                    return {
                        name: subAssignment.name,
                        type: 'sub-assignment',
                        id: subAssignment.id,
                        order: subAssignment.order,
                        rating_type: subAssignment.portfolio_rating ? subAssignment.portfolio_rating.type : null,
                        rating_result:
                            subAssignment.portfolio_rating && subAssignment.portfolio_rating.results.length !== 0
                                ? subAssignment.portfolio_rating.results[0].value
                                : null,
                    };
                });

                allRatings.unshift({
                    name: this.assignmentIn.name,
                    type: 'assignment',
                    id: this.assignmentIn.id,
                    order: 0,
                    rating_type: this.assignmentIn.portfolio_rating ? this.assignmentIn.portfolio_rating.type : null,
                    rating_result:
                        this.assignmentIn.portfolio_rating && this.assignmentIn.portfolio_rating.results.length !== 0
                            ? this.assignmentIn.portfolio_rating.results[0].value
                            : null,
                });
            }

            return allRatings;
        },
    },
};
</script>

<style scoped lang="scss">
.ratings-list-group {
    .rating-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: none;
        padding-left: 0;

        .title {
            font-weight: $font-weight-bold;
        }

        &:not(:first-child) {
            padding-left: map-get($grid-gutter-spacing, 'twenty-one');

            .title {
                font-weight: $font-weight-medium;
            }
        }

        &:not(:last-child) {
            border-bottom: 3px dotted $border-color;
        }
    }
}
</style>
